import React, { Component } from 'react';
import { withRouter }  from 'react-router-dom';
import findIndex from 'array.prototype.findindex';
import { animateScroll as scroll } from 'react-scroll'

import './ProgressBar.scss';

findIndex.shim(); 

class ProgressBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [
        {
          name: "Fees & important info",
          route: "/RatesFees"
        },
        {
          name: "Personal info",
          route: "/PersonalInfo",
          steps: [
            {route: "/PersonalInfo/Name" },
            {route: "/PersonalInfo/Birthdate" },
            {route: "/PersonalInfo/Contact" },
            {route: "/PersonalInfo/Address" },
            {route: "/PersonalInfo/PreviousAddress" },
            {route: "/PersonalInfo/LivingSituation"}
          ]
        },
        {
          name: "Occupation",
          route: "/Occupation"
        },
        { 
          name: "Income & expense",
          route: "/IncomeExpenses",
          steps: [
            { route: "/IncomeExpenses" },
            { route: "/IncomeExpenses/Finances" }
          ]
        },
        { 
          name: "Authorized users",
          route: "/AuthorizedUsers",
          steps: [
            {route: "/AuthorizedUsers" },
            {route: "/AuthorizedUsers/Add" }
          ]
        },
        { 
          name: "Balance protection",
          route: "/Bpi",
          steps: [
            {route: "/Bpi" }
          ]
        },
        { 
          name: "Review & confirm identity",
          route: "/Review",
          steps: [
            {route: "/Review" },
            {route: "/Review/ConfirmIdentity" },
          ]
        },
        { 
          name: "Consent & submit",
          route: "/Submit"
        }
      ]
    }
  }
  componentDidUpdate(prevProps) {    
    if(prevProps.location.pathname !== this.props.location.pathname) {    
      scroll.scrollToTop({smooth : false, duration: 0});
    }
  }
  render() {
    let path = this.props.location.pathname;    
    let route = `/${path.split("/")[1]}`;
    
    let progressWidth;
    let stepWidth = (100 / (this.state.steps.length - 1));    

    // check if route exists in steps array
    let displayProgressBar = false;
    if(this.state.steps.filter(step => step.route === route).length > 0) {
      displayProgressBar = true;
    }

    let activeClass = " active";
    let currentStep = "";

    // Construct the steps
    let steps;
    if(displayProgressBar) {
      steps = this.state.steps.map((step, i) => {
        let stepStyle = {left: `${stepWidth * i}%`}
        let last = "";
        if(activeClass === " current") {
          activeClass = "";
        }
        if(step.route === route) {
          // Check if there are child steps
          let extraWidth = 0;
          if(("steps" in step) && step.steps.length > 0) {
            let routeIndex = step.steps.findIndex(step => step.route === path);
            if(routeIndex >= 0) {
              extraWidth = (stepWidth / step.steps.length) * routeIndex;
            }
          }
          progressWidth = { width: `${(stepWidth * i) + extraWidth}%`};
          activeClass = " current";    
          currentStep = step.name;      
        }
        if(this.state.steps.length - 1 === i) {
          last = " last";
        }
        return (<div style={stepStyle} key={i} className={"step" + activeClass + last}><div className="circle"></div><div className="label">{step.name}</div></div>)
      });
    }

    return (
      <div className="progress-bar-container">
        <div className={"progress-bar-bg" + (!displayProgressBar ? "-lite" : "")}></div>
        {steps}
        <div className={"progress-bar" + (!displayProgressBar ? " hidden" : "")}  style={progressWidth}></div>
        <div className="step-mobile">{currentStep}</div>
      </div>
    );
  }
}

ProgressBar.defaultProps= {
};

ProgressBar.propTypes = {

};
export default withRouter(ProgressBar);


// WEBPACK FOOTER //
// ./src/containers/ProgressBar/ProgressBar.js